export const REP_LIST_FETCH         = 'REP_LIST_FETCH';
export const REP_LIST_FETCH_DONE    = 'REP_LIST_FETCH_DONE';
export const SEARCH_REP             = 'SEARCH_REP';
export const SEARCH_REP_DONE        = 'SEARCH_REP_DONE';
export const REP_LIST_UPDATE        = 'REP_LIST_UPDATE';
export const BLOCK_REP              = 'BLOCK_REP';
export const UNBLOCK_REP            = 'UNBLOCK_REP';
export const ACTIVATE_REP           = 'ACTIVATE_REP';



// WEBPACK FOOTER //
// ./app/constants/repTypes.js